// `broadcast.test.v1` — Stage 3 ONLY. Smoke-test event emitted via the
// internal `/api/marketing/internal/emit-test-event` route to verify the
// EventBridge → Inngest dashboard → MarketingWorker → MarketingStatusTable
// path end-to-end in dev.
//
// This event MUST be removed (along with the emit-test-event route) before
// Stage 4 ships, OR gated behind a feature flag with a dev-only default.
// The TODO is documented in backends/marketing/CLAUDE.md.
//
// detailType in EventBridge: `broadcast.test.v1` (Commitment 6).

import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const broadcastTestV1Schema = eventEnvelopeSchema.extend({
  // Free-form note from the engineer who fired the smoke event, surfaced
  // in workflow logs so you can correlate test events from multiple
  // sources in CloudWatch / Inngest UI.
  smokeNote: z.string().max(512).default('manual-smoke-test'),
});

export type BroadcastTestV1 = z.infer<typeof broadcastTestV1Schema>;

export const BROADCAST_TEST_V1_DETAIL_TYPE = 'broadcast.test.v1' as const;
